<div class="signup-main">
    <ng-container *ngIf="(canDisplaySignupForm$ | async) && (stripeLoaded$ |async); else formLoading">
        <div class="signup-main-header">
            <div *ngIf="planName === 'Smash Team'"
                class="signup-main-header-title">{{ 'SIGNUP_HEADER_TITLE_SUBSCRIBE_PLAN' | translate:{plan: planName } }} ({{ planMaxUsers }} {{ 'PREMIUM_SIDE_NAV_SUBTITLE_USERS' | translate | firstLetterLowercase}})</div>
            <div *ngIf="planName !== 'Smash Team'"
                class="signup-main-header-title">{{ 'SIGNUP_HEADER_TITLE_SUBSCRIBE_PLAN' | translate:{plan: planName } }}</div>
            <div class="signup-main-header-subtitle">
                {{ 'SIGNUP_HEADER_SUBTITLE' | translate }}
            </div>
        </div>
        <div class="form-container">
            <app-smash-signup-form [environment]="(environment$ | async)"
                [account]="(account$ | async)"
                [countries]="(countries$ | async)"
                [billingsInformations]="(billingsInformations$ | async)"
                [planGroup]="(planGroup$ | async)"
                [computedPlan]="(computedPlan$ | async)"
                [countryCode]="(countryCode$ | async)"
                [subscription]="(subscription$ | async)"
                [errorSubscription]="(signupError$ | async)"
                (formDataUpdated)="updateFormData($event)"
                (formDataSubmitted)="signUp($event)"
                [planName]="planName"
                [language]="(language$ | async)">
            </app-smash-signup-form>
        </div>
    </ng-container>
    <ng-template #formLoading>
        <div class="loading-spinner-container">
            <div class="loading-spinner-grey"></div>
        </div>
    </ng-template>
</div>